import React, { Component } from 'react';
import YouTube from 'react-youtube';
import '../components/YouTubeEmbed.css';
import './Page.css';
import './Account.css';

import { API_BASE } from '../config';

import { Link } from 'react-router';

import Authentication from '../Authentication';
import Button from '../components/Button';
import Input from '../components/Input';
import ListItem from '../components/Store--List--Item';
import Notification from '../components/Notification';

import RSSlogo from '../images/RSS_logo-dark.svg';
import referral_image from '../images/ReallySimpleReferral@2x.png';

class Account extends Component {

  constructor(props) {
    super(props);

    this._createStore = this._createStore.bind(this);
    this._getUserStores = this._getUserStores.bind(this);
    this._getUser = this._getUser.bind(this);
    this._toggleReferral = this._toggleReferral.bind(this);

    this.state = {
      notification_text:"",
      referralInputHidden:true,
      stores:[],
      user_id:localStorage.getItem('user_id'),
      user:{
        name:"",
        email:""
      },
      welcome_message:this.props.params.welcome || false
    };

  }

  componentDidMount() {

    this._getUser();
    this._getUserStores();

  }

  render() {

      return (
        <div>
          <Notification text={this.state.notification_text} />

          <div className='App-signIn Page Page-Wide clearfix'>
          
            <div className="Account">

                <h1>Manage Stores</h1>
                <p><strong>Welcome to your Really Simple Store account.</strong> <br />Choose a store to manage.</p>

                <div className="stores_list clearflex">
                  <div className="stores_list--item one-third column clearflex">
                    <div>
                      <Button label="&nbsp;" text={this.state.stores.length > 0 ? "+ Create a New Store" : "+ Create Your First Store" } onClick={this._createStore} />
                      <p className="hint">Free to build, then $5/month when you go live.</p>
                    </div>
                  </div>
                  {this.state.stores.length ? this.state.stores.map((item,index) => (
                    <ListItem key={index} store={item} />
                  )) : null}
                </div>

            </div>

            <div className="footer" style={{padding:"2em",textAlign:"center",marginTop:"8em",borderTop:"1px solid rgba(0,0,0,.15)"}}>
              <p><strong>Really Simple Store</strong></p>
              <p><a href="mailto:drew@reallysimplestore.com">drew@reallysimplestore.com</a></p>
              <p>&nbsp;</p>
              <p>&copy; 2019 Work and Whistle, LLC | Austin, TX USA</p>
            </div>
          </div>

        </div>
        
      );
  
  }

  _createStore() {
    var _this = this;

    var request = new Request(`${API_BASE}stores?email=`+_this.state.user.email+"&user_id="+_this.state.user_id, {
      method: 'POST', 
      mode: 'cors',
      headers: new Headers({
        'Authorization': localStorage.getItem('token')
      })
    });

    this.setState({notification_text:"Setting up store..."});
    fetch(request).then(function(response) {
      return response.json();
    }).then(function(json) {

      //_this._getUserStores();
      window.location.href = "//settings.reallysimplestore.com/"+json.permalink;

    }).catch(function(ex) {
      console.log('parsing failed', ex);
    });
  }

  _getUser() {
    
    var _this = this;

    var request = new Request(`${API_BASE}users/`+_this.state.user_id, {
      method: 'GET', 
      mode: 'cors',
      headers: new Headers({
        'Authorization': localStorage.getItem('token')
      })
    });

    fetch(request).then(function(response) {
      return response.json();
    }).then(function(json) {

      _this.setState({
        user:json
      });

    }).catch(function(ex) {
      console.log('parsing failed', ex);
    });
  }

  _getUserStores() {
    
    var _this = this;

    var request = new Request(`${API_BASE}users/stores/`+_this.state.user_id, {
      method: 'GET', 
      mode: 'cors',
      headers: new Headers({
        'Authorization': localStorage.getItem('token')
      })
    });

    fetch(request).then(function(response) {
      return response.json();
    }).then(function(json) {

      _this.setState({
        stores:json
      });

    }).catch(function(ex) {
      console.log('parsing failed', ex);
    });
  }

  _toggleReferral() {
    this.setState({
      referralInputHidden:!this.state.referralInputHidden
    })
  }

}

export default Account;



// WEBPACK FOOTER //
// ./src/pages/Account.js